/**
 * Copyright (c) 2023-present,
 * Eunoia Digital, S.L. All rights reserved.
 */

const personal = {
  AlfonsoLopez: {
    img: '/static/images/representants/AlfonsoLopez.webp',
    nom: 'Alfonso López',
    carrec: 'Area Manager Colombia',
    email: 'alfonso.lopez@manvert.com',
  },
  AndresArguedas: {
    img: '/static/images/representants/AndresArguedas.webp',
    nom: 'Andrés Arguedas',
    carrec: 'Area Manager Centroamérica & Caribe',
    email: 'andres.arguedas@manvert.com',
  },
  CesarGaete: {
    img: '/static/images/representants/CesarGaete.webp',
    nom: 'César Gaete',
    carrec: 'Country Manager Chile',
    email: 'cesar.gaete@manvert.com',
  },
  EhabMostafa: {
    img: '/static/images/representants/EhabMostafa.webp',
    nom: 'Ehab Ibrahim Mohamed Mostafa',
    carrec: 'MENA & Turkey Area Manager',
    email: 'ehab.mostafa@manvert.com',
  },
  JoseLuisHerreraTorre: {
    img: '/static/images/representants/JoseLuisHerreraTorre.webp',
    nom: 'José Luis Herrera de la Torre',
    carrec: 'Business unit manager',
    email: 'jose.herrera@manvert.com',
  },
  JosepPinassa: {
    img: '/static/images/representants/JosepPinassa.webp',
    nom: 'Josep Pinassa',
    carrec: 'Director Comercial Iberia',
    email: 'j.pinassa@manvert.com',
  },
  JuanGimenez: {
    img: '/static/images/representants/JuanGimenez.webp',
    nom: 'Juan Giménez',
    carrec: 'Technical Support Manager',
    email: 'juan.gimenez@manvert.com',
  },
  JuanMariaDurany: {
    img: '/static/images/representants/JuanMariaDurany.webp',
    nom: 'Juan Maria Durany',
    carrec: 'Responsable comercial España',
    email: 'jmdurany@manvert.com',
  },
  LoretoGomez: {
    img: '/static/images/representants/LoretoGomez.webp',
    nom: 'Loreto Gómez',
    carrec: 'Area Manager Chile & Perú',
    email: 'loreto.gomez@manvert.com',
  },
  PedroVilchez: {
    img: '/static/images/representants/PedroVilchez.webp',
    nom: 'Pedro Vílchez',
    carrec: 'Area Manager Colombia, CA & C',
    email: 'pedro.vilchez@manvert.com',
  },
  PepeAndres: {
    img: '/static/images/representants/PepeAndres.webp',
    nom: 'Pepe Andrés',
    carrec: 'Responsable Comercial Marruecos',
    email: 'pepe.andres@manvert.com',
  },
  RicardNavas: {
    img: '/static/images/representants/RicardNavas.webp',
    nom: 'Ricard Navas',
    carrec: 'Export Manager',
    email: 'ricard.navas@manvert.com',
  },
  SaidMeskine: {
    img: '/static/images/representants/SaidMeskine.webp',
    nom: 'Said Meskine',
    carrec: 'Business unit manager',
    email: 'said.meskine@manvert.com',
  },
};

const data: any = {
  alg: [personal.EhabMostafa],
  arab: [personal.EhabMostafa],
  arg: [personal.LoretoGomez],
  bolivia: [personal.PedroVilchez],
  venezuela: [personal.PedroVilchez],
  chil: [personal.LoretoGomez],
  col: [personal.PedroVilchez],
  cosmarfil: [personal.SaidMeskine],
  cosrica: [personal.PedroVilchez],
  esp: [personal.JosepPinassa],
  egipto: [personal.EhabMostafa],
  sal: [personal.PedroVilchez],
  guat: [personal.PedroVilchez],
  hon: [personal.PedroVilchez],
  jordan: [personal.EhabMostafa],
  ken: [personal.JuanGimenez],
  lebanon: [personal.EhabMostafa],
  morroco: [personal.PepeAndres],
  nam: [personal.JuanGimenez],
  nic: [personal.PedroVilchez],
  pan: [personal.PedroVilchez],
  par: [personal.LoretoGomez],
  per: [personal.LoretoGomez],
  por: [personal.JosepPinassa],
  rd: [personal.PedroVilchez],
  sen: [personal.SaidMeskine],
  sudaf: [personal.JuanGimenez],
  sud: [personal.EhabMostafa],
  tun: [personal.EhabMostafa],
  tur: [personal.EhabMostafa],
  uru: [personal.LoretoGomez],
  usa: [personal.JuanGimenez],
  yem: [personal.EhabMostafa],
  zim: [personal.SaidMeskine],
  repDom: [personal.PedroVilchez],
};

const paises: any = {
  alg: 'Algeria',
  arab: 'Arabia Saudí',
  arg: 'Argentina',
  bolivia: 'Bolivia',
  chil: 'Chile',
  col: 'Colombia',
  cosrica: 'Costa Rica',
  egipto: 'Egipto',
  esp: 'España',
  sal: 'El Salvador',
  guat: 'Guatemala',
  hon: 'Honduras',
  jordan: 'Jordania',
  lebanon: 'Líbano',
  morroco: 'Marruecos',
  nic: 'Nicaragua',
  por: 'Portugal',
  pan: 'Panamá',
  par: 'Paraguay',
  per: 'Perú',
  sudaf: 'Sudáfrica',
  sud: 'Sudán',
  tun: 'Túnez',
  tur: 'Turquía',
  uru: 'Uruguay',
  venezuela: 'Venezuela',
  yem: 'Yemen',
  repDom: 'República Dominicana',
  others: 'Otros países',
};

const paisesEng: any = {
  alg: 'Algeria',
  arab: 'Saudi Arabia',
  bolivia: 'Bolivia',
  arg: 'Argentina',
  chil: 'Chile',
  col: 'Colombia',
  cosrica: 'Costa Rica',
  egipto: 'Egypt',
  esp: 'Spain',
  sal: 'El Salvador',
  guat: 'Guatemala',
  hon: 'Honduras',
  jordan: 'Jordan',
  lebanon: 'Lebanon',
  morroco: 'Morocco',
  nic: 'Nicaragua',
  por: 'Portugal',
  pan: 'Panama',
  par: 'Paraguay',
  per: 'Peru',
  sudaf: 'South Africa',
  sud: 'Sudan',
  tun: 'Tunisia',
  tur: 'Turkey',
  uru: 'Uruguay',
  yem: 'Yemen',
  repDom: 'Dominican Republic',
  venezuela: 'Venezuela',
  others: 'Other countries',
};

export { data, paises, paisesEng };
